export const DEFAULT_TASK_FOLDER_ID = 'tasks';
export const TODO_TASKS_RENDERED = 'ToDoTasksRendered';
